import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ConfigurationState, ConfigurationTreeNodeModel } from '@/types';

export const state: ConfigurationState = {
  tree: [] as ConfigurationTreeNodeModel[],
  expandSelectedNodeOnMount: false,
  isLoading: false,
  error: false,
  errorMessage: '',
  entraEnabled: false
};

const namespaced: boolean = true;

export const configuration = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
